// Licensed under Gnu Public License version 2
// Copyright (c) 2024 - 2025 (original work) Open Assessment Technologies SA ;

import config from '@/config';
import { getPermissionsGuard } from '@/core/guards/permissionsGuard.js';

export default [
    {
        path: [config.routes.certificationSessions.mySessions],
        guard: getPermissionsGuard([{ resource: 'portal.my-session', scopes: ['view'] }]),
        controller: () => import('./controllers/mySessions')
    },
    {
        path: [config.routes.certificationSessions.enrollmentSessions],
        guard: getPermissionsGuard([
            { resource: 'portal.my-session', scopes: ['view', 'self-enrol'] },
            { resource: 'portal.payment', scopes: ['create'] }
        ]),
        controller: () => import('./controllers/enrollmentSessions')
    },
    {
        path: [config.routes.certificationSessions.myAssignedSessions],
        guard: getPermissionsGuard([{ resource: 'portal.staff-member-session-room', scopes: ['view', 'create'] }]),
        controller: () => import('./controllers/myAssignedSessions')
    }
];
